<template>
    <div class="footer">
        <div class="fixed">
            <div class="left">
                <p>武汉高德信息产业有限公司</p>
                <ul>
                    <li v-for="(value,index) in footerList" :key="index" @click="changePage(value.url)">{{value.name}}</li>
                </ul>
            </div>
            <div class="middle">
                <ul>
                    <li>Copyright©2016 鄂ICP备15018399号-1</li>
                    <li>地址：湖北省武汉市东湖新技术开发区华工科技园创业SOHO大厦B座17楼</li>
                    <li>电话：027-87528232</li>
                    <li>邮箱：market@gdcourse.com</li>
                </ul>
            </div>
            <div class="right">
                <div class="qr">
                    <div>智能制造·立方学院</div>
                </div>
                <div class="qr qr2">
                    <div>立方学院微信公众号</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'commonfooter',
    data(){
        return{
            footerList:[{
                name:'公司介绍',
                url:'/aboutIntroduction'
            },{
                name:'荣誉资质',
                url:'/aboutHonour'
            },{
                name:'人才计划',
                url:'/aboutTalent'
            },{
                name:"公司新闻",
                url:'/aboutNews'
            },{
                name:"校企合作",
                url:'/aboutOperative'
            },{
                name:'联系我们',
                url:'/aboutUs'
            }]
        }
    },
    methods:{
        changePage(data){
            this.$router.push({path:data})
        }
    }
}
</script>
<style lang="stylus" scoped>
    .footer
        width:100%;
        background:#262626;
        color:#fff;
        .fixed
            display:flex;
            justify-content:space-between;
            padding:30px 0;
            .left
                p
                    margin-top:20px;
                    font-size:18px;
                    color:#fff;
                ul
                    display:flex;
                    padding-left:0;
                    li
                        margin-right:10px;
                        font-size:14px;
                        color:#949498;
                        cursor:pointer
                        &:hover
                            color:#fff;
            .middle
                font-size:14px;
                li
                    margin-top:8px;
                    color:#949498;
            .right
                display:flex;
                justify-content space-between;
                margin-top:15px;
                .qr
                    width:95px;
                    height:95px;
                    background:url('../assets/qr1.png') no-repeat;
                    padding-bottom:20px;
                    position relative
                    margin-right:15px;
                    cursor pointer;
                    &:hover
                        background:url('../assets/qr1-1.png') no-repeat;
                        div
                            color:#fff;
                    div
                        font-size:12px;
                        position:absolute;
                        bottom:-18px;
                        width:115%;
                        color:#949498;
                        left:-5px;
                .qr2
                    background:url('../assets/qr2.png') no-repeat;
                    &:hover
                        background:url('../assets/qr2-2.png') no-repeat;
                        
            
                
</style>